import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/rem'
import { message, Pagination, Empty, Input, Spin, Drawer, Modal } from 'ant-design-vue'
import verify from './utils/verify'
import util from './utils/util'

Vue.use(Pagination)
Vue.use(Empty)
Vue.use(Input)
Vue.use(Spin)
Vue.use(Drawer)
Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$util = util
Vue.prototype.$verify = verify
Vue.prototype.$message = message
Vue.config.productionTip = false

//  路由变化
router.beforeEach((to, from, next) => {
  var n = () => {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }
  if (to.meta.token) {
    if (window.localStorage.getItem('token')) {
      n()
    } else {
      message.error('请先登录您的账号')
      next({ path: '/login' })
    }
  } else {
    n()
  }
})

// 防止重复点击
Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
